import React, { useState } from 'react';
import ProcessCard from './ProcessCard';
import Modal from './Modal';
import ProcessForm from './ProcessForm';

const processes = [
  {
    processNumber: '# 01',
    processName: 'Candidatos Abogados Junior',
    startDate: '12/05/2024',
    daysAgo: 128,
    status: 'Iniciado',
    stages: [
      { label: 'Postulantes', count: 0 },
      { label: 'Entrevista HR', count: 0 },
      { label: 'Entrevista Jefe Directo', count: 0 },
      { label: 'Entrevista Par Cesar', count: 0 },
      { label: 'Contratados', count: 1 },
    ],
  },
  {
    processNumber: '# 91',
    processName: 'Candidato a Asesor Comercial',
    startDate: '11/05/2024',
    daysAgo: 129,
    status: 'Iniciado',
    stages: [
      { label: 'Postulantes', count: 0 },
      { label: 'LLAMADA RECLUTADOR', count: 0 },
      { label: 'ENTREVISTA PRESENCIAL RRHH', count: 0 },
      { label: 'PRUEBAS CONOCIMIENTO', count: 0 },
      { label: 'ENTREVISTA GERENTE', count: 0 },
      { label: 'EXAMENES MEDICOS', count: 0 },
      { label: 'Contratados', count: 0 },
    ],
  },
];

const ProcessList: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Procesos de selección</h1>
      <div className="flex gap-4 mb-4">
        <button className="bg-blue-500 text-white px-4 py-2 rounded-md">Procesos</button>
        <button className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md">Estadísticas</button>
        <input type="text" placeholder="Buscar" className="border border-gray-300 px-4 py-2 rounded-md" />
        <select className="border border-gray-300 px-4 py-2 rounded-md">
          <option>Mostrar iniciados (19)</option>
          {/* Añadir más opciones según sea necesario */}
        </select>
        <button onClick={openModal} className="bg-blue-500 text-white px-4 py-2 rounded-md">Crear Proceso</button>
      </div>
      <div>
        {processes.map((process, index) => (
          <ProcessCard key={index} {...process} />
        ))}
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ProcessForm />
      </Modal>
    </div>
  );
};

export default ProcessList;
